import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource/ibm-plex-mono/700.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import { installSession } from '@/auth/session'
import '@/styles/globals.css'

// До первого рендера: страницы начинают запросы раньше, чем отработают эффекты, и запрос,
// ушедший до связывания стора с клиентом, потерял бы токен.
installSession()

const root = document.getElementById('root')
if (!root) throw new Error('Не найден #root — проверь index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
